
   
import Vue from 'vue'
import VueRouter from 'vue-router'
  
import C2KHM95UE4W68LNYIZ1RSTVP3OFJBGAD7QX0 from './views/dcfk/dcbg.vue';
import pacs from './views/yjts/Index.vue';
import shjhpacs from './views/yjts/shjh_ct.vue';
import test1 from './views/test/test.vue';

 
Vue.use(VueRouter)
  
const routes = [
	{ 
    path: '/C2KHM95UE4W68LNYIZ1RSTVP3OFJBGAD7QX0',
    component: C2KHM95UE4W68LNYIZ1RSTVP3OFJBGAD7QX0
  },
	{ 
    path: '/pacs',
    component: pacs
  },
	{ 
    path: '/shjhpacs',
    component: shjhpacs
  },
	// { 
  //   path: '/test1',
  //   component: test1
  // },
];
  
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })
  
router.beforeEach((to, from, next) => {

	if (to.path == '/shjhpacs') {
		document.title = "在线阅片";
	}

	if (to.path == '/pacs') {
		document.title = "在线阅片";
	}
	if (to.path == '/C2KHM95UE4W68LNYIZ1RSTVP3OFJBGAD7QX0') {
		document.title = "调查问卷";
	}
	next()
})
export default router
  